<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="300"
    >
        <v-card>
            <v-card-title>
                {{ 'Tem certeza?' | translate('BillDialog') }}
            </v-card-title>
            <v-card-text style="justify-content: center;">
                {{ 'Você realmente deseja faturar o pedido?' | translate('BillDialog') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    class="white--text btn1" 
                    small
                    color="black"
                    @click="input()"
                >
                    {{'Não' | translate('BillDialog')}}
                </v-btn>
                <v-btn 
                    class="white--text btn1" 
                    small
                    color="black"
                    @click="closeModal()"
                >
                    {{'Sim' | translate('BillDialog')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'BillDialog',
    props: ['dialog'],
    methods : {
        input(){
            this.$emit('input')
            this.closeModal()
        },
        closeModal(){
            this.$emit('close')
        }
    }
}
</script>
